import { useSelector } from "react-redux";

const useFeatureChecks = () => {
  const commonState = useSelector((state) => state.commonReducer);
  const { myProfile, tenantPermissionsInfo } = commonState;

  const checkRolesAndPermissionsFeature = (menu) => {
    let isRolesAndPermissionFeatuePresent = false;
    const associatedRolesId = myProfile?.AssociatedRoles?.map(
      (data) => data?.RoleID
    );
    tenantPermissionsInfo?.forEach((permission) => {
      if (menu?.roleMenu === permission?.PermissionName) {
        associatedRolesId?.forEach((data) => {
          if (permission?.AssociatedRoles?.includes(data?.toString())) {
            isRolesAndPermissionFeatuePresent = true;
          }
        });
      }
    });
    return isRolesAndPermissionFeatuePresent;
  };

  const checkMSOMFeature = (menu) => {
    let isMSOMFeatuePresent = false;
    myProfile?.TenantFeatures?.forEach((item) => {
      if (menu?.MSOMMenu === item?.Name) isMSOMFeatuePresent = true;
    });
    return isMSOMFeatuePresent;
  };

  return { checkRolesAndPermissionsFeature, checkMSOMFeature };
};

export default useFeatureChecks;
